<template>
    <span class="ah-select-client">
        <el-select
            v-model="inputVal"
            filterable
            clearable
            remote
            reserve-keyword
            :placeholder="companyInfo.displayClient ? '請選擇' : '請輸入客戶關鍵字（至少兩個字）'"
            :no-data-text="companyInfo.displayClient ? '無資料' : '無匹配資料'"
            :remote-method="remoteLoad"
            :loading="isLoading"
            loading-text="搜尋中"
            no-match-text="沒有匹配的客戶"
            :disabled="disabled"
            @change="handleSelectChange"
            @clear="handleClear"
            @keydown.native.capture.enter="preventIMESelect"
        >
            <el-option v-for="item in options" :key="item.sno" :label="item.fnam" :value="item.sno"> </el-option>
        </el-select>
    </span>
</template>
<script>
export default {
    name: 'ah-select-client',
    props: {
        value: {
            type: Number,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    components: {},
    data() {
        return {
            isLoading: false,
            options: [],
        };
    },
    computed: {
        inputVal: {
            get() {
                console.log('newVal', this.value);
                if (this.value !== null) {
                    // 編輯時，載入已選的客戶資料，否則只會顯示sno數字
                    this.loadSelectedItem(this.value);
                }
                return this.value;
            },
            set(val) {
                this.$emit('input', val === '' ? null : val);
            },
        },
        companyInfo() {
            return this.$store.getters['menu/companyInfo'];
        },
    },
    mounted() {
        this.fetchClientOptions();
    },
    methods: {
        remoteLoad(keyword) {
            this.fetchClientOptions(keyword);
        },
        loadSelectedItem(clientSno) {
            this.$api({
                url: 'VendorManagementPage/GetVendorInfo',
                params: { SNO: clientSno },
                method: 'GET',
            }).then((resp) => {
                this.options = [resp.data.item];
            });
        },
        async fetchClientOptions(keyword = '') {
            this.isLoading = true;
            const resp = await this.$api({
                url: 'InvoiceManagemNetPage/GetVendorList',
                params: { keyword, PageSize: 999, PageNum: 1 },
                method: 'GET',
            });
            this.options = resp.data.items;
            this.isLoading = false;
        },
        handleSelectChange(clientSno) {
            this.$emit('change', clientSno);
        },
        handleClear() {
            this.options = [];
            this.$emit('clear');
        },
        preventIMESelect(e) {
            // keyCode 229 代表輸入法正在輸入
            if (e.keyCode === 229 || e.isComposing) {
                // 停止事件冒泡，防止觸發 Element-UI 內部的 handleKeydown
                e.stopPropagation();
            }
        },
    },
};
</script>
<style lang="scss">
.ah-select-client {
    .el-input > input {
        width: 400px;
        margin-right: 5px;
        cursor: text;
    }
}
</style>
